import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69408466e534c900144bc0f8_1784605037767_2989fbfc/diaax_advisory/src/app/case-studies/components/CaseStudyPage.tsx");
